import { Injectable, EventEmitter } from '@angular/core';
import { UserManager, User } from 'oidc-client';
import { environment } from '../../../environments/environment';
import { authConfig } from '../../auth.config';
import { AppConstants } from '../constants/constants';

@Injectable()
export class AuthService {
    mgr: UserManager = new UserManager(authConfig);
    constructor() {
        this.addUserLoaded();
    }
    login(){
        this.mgr.signinRedirect({state: this.randomKey()}).then(function () {
            console.log('signinRedirect done');
          }).catch(function (err) {
            console.log(err);
          });

    }
    clearStaleState(): Promise<void> {
        return this.mgr.clearStaleState();
    }
    getUser(): Promise<User>{
        return this.mgr.getUser();
    }
    addUserLoaded() {
        this.mgr.events.addUserLoaded((user) => {
            const currentTime = new Date().valueOf();
            const lastAccessDate = new Date(localStorage.getItem(AppConstants.localStorage.lastAccessDate));
            const sessionTime =  lastAccessDate.setSeconds(lastAccessDate.getSeconds() + environment.sessionExpiredDuration);
            if (sessionTime >= currentTime) {
                this.setLocalStorage(user);
            }
        });
    }
    private setLocalStorage(user: User) {
        localStorage.setItem('profile', JSON.stringify(user.profile));
        localStorage.setItem(AppConstants.activeLink.userId, user.profile['sub'].toString());
        localStorage.setItem(AppConstants.localStorage.token, user.access_token);
        localStorage.setItem(AppConstants.localStorage.idToken, user.id_token);
        localStorage.setItem(AppConstants.localStorage.expireTime, user.expires_in.toString());
        localStorage.setItem(AppConstants.localStorage.tokenType, user.token_type);
        localStorage.setItem(AppConstants.localStorage.scope, user.scope);
        localStorage.setItem(AppConstants.localStorage.state, user.state);
        localStorage.setItem(AppConstants.localStorage.sessionState, user.session_state);

        // Set expire date
        const expireDate = new Date();
        expireDate.setSeconds(expireDate.getSeconds() + parseInt(localStorage.getItem(AppConstants.localStorage.expireTime)));
        localStorage.setItem(AppConstants.localStorage.expireDate, expireDate.toString());
        
        // set user info
        if (user.profile != null) {
            localStorage.setItem(AppConstants.localStorage.firstName, user.profile[AppConstants.localStorage.firstName]);
            localStorage.setItem(AppConstants.localStorage.lastName, user.profile[AppConstants.localStorage.lastName]);
            localStorage.setItem(AppConstants.localStorage.userName, user.profile[AppConstants.localStorage.firstName] + ' ' + user.profile[AppConstants.localStorage.lastName]);
        }
    }
    logout(){
        this.mgr.signoutRedirect({ 
            id_token_hint: localStorage.getItem(AppConstants.localStorage.idToken),
            state: localStorage.getItem(AppConstants.localStorage.state),
            post_logout_redirect_uri: environment.authConfig.postLogoutRedirectUri
        }).then(function (resp) {
            console.log('signed out - eeeeeeeeeeeee', resp);
          }).catch(function (err) {
            console.log(err);
          });
    }
    processCallback(url:string):Promise<User>{
        return this.mgr.signinRedirectCallback(url);
    }

    // signinRedirectCallback():Promise<User>{
    //     return this.mgr.signinRedirectCallback();
    // }

    signinRedirectCallback(url:string):Promise<User>{
        return this.mgr.signinRedirectCallback(url);
    }

    processRefresh(): Promise<User> {
        return this.mgr.signinSilent();
    }
    processCallbackRefresh(){
        this.mgr.signinSilentCallback();
    }
    private randomKey()
    {
        var /** @type {?} */ text = '';
        var /** @type {?} */ possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var /** @type {?} */ i = 0; i < 40; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        
        return text;
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/services/auth.service.ts